module.exports = __webpack_public_path__ + "img/hardwareRouter3.59564494.png";